import React from 'react';
import { Box, Typography } from 'housecall-ui';

import { InvoiceData } from '../../api/payment/api';
import { CartItemDisplay } from '../../components/Cart/CartItemDisplay';
import { useOrgData } from '../../hooks/useOrgData';
import { useOnlineBookingReducer } from '../../state/useOnlineBookingReducer';
import { roundNumber } from '../../utils/roundPrice';
import { getDepositLabel } from './utils';

type Props = {
  invoiceData: InvoiceData;
};

export const InvoiceDetails = ({ invoiceData }: Props) => {
  const { state } = useOnlineBookingReducer();
  const { token } = state;
  const { data: orgData } = useOrgData({ token });

  const orgTax = orgData?.taxInfo;

  const taxName = `Tax, ${orgTax?.name || 'N/A'} (${roundNumber((orgTax?.rate || 0) * 100)}%):`;

  const hasDeposit = invoiceData.template === 'deposit';

  return (
    <>
      <Box mb={1}>
        <Typography variant="subtitle1">Pricing</Typography>
      </Box>
      <Box mb={1}>
        <CartItemDisplay title="Subtotal:" boldPrice price={invoiceData?.subtotal} />
      </Box>
      <Box mb={1}>
        <CartItemDisplay title={taxName} boldPrice price={roundNumber(invoiceData.total - invoiceData.subtotal)} />
      </Box>
      <Box mb={1}>
        <CartItemDisplay bold title="Total:" price={invoiceData.total} />
      </Box>
      {hasDeposit && orgData && (
        <Box mb={1}>
          <CartItemDisplay bold title={getDepositLabel(orgData.paymentSettings)} price={invoiceData.dueAmount} />
        </Box>
      )}
    </>
  );
};

export default InvoiceDetails;
